import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import dashboardSlice from "./slices/dashboardSlice";
import categorySlice from "./slices/categorySlice";
import courseSlice from "./slices/courseSlice";
import testSlice from "./slices/testSlice";
import communityForumSlice from "./slices/communityForum";
import cmsSlice from "./slices/cmsSlice";
import chatSlice from "./slices/chatSlice";
import languageSlice from "./slices/languageSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    category: categorySlice,
    course: courseSlice,
    test:testSlice,
    communityForum:communityForumSlice,
    cms:cmsSlice,
    chat: chatSlice,
    language:languageSlice,
  },
  devTools: process.env.NODE_ENV === 'development',
});
